"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productAPISearchTool = void 0;
const zod_1 = require("zod");
exports.productAPISearchTool = {
    name: 'productAPISearch',
    description: `Search for products, shop items, or get product categories using avatar's configured SmartShop API. Use this tool when users ask about products, shopping, buying, purchasing, or want to browse a shop/store. This tool supports two operations:
        
        1. 'searchProducts' - Search for products by name, category, and with pagination controls
        2. 'getCategories' - Get the list of available product categories
        
        Use this tool for any product-related queries including: finding products, browsing shop items, looking for things to buy, checking product availability, exploring categories, or general shopping assistance.

        Dont use tables for comparison while talking about products - the frontend will handle this.
        Set isComparingProducts to true when users ask to compare products specifically.
        
        The tool will automatically check if the SmartShop service is enabled for the current avatar before performing any operation.`,
    zodSchema: zod_1.z.object({
        operation: zod_1.z.enum(['searchProducts', 'getCategories']).describe('The operation to perform: searchProducts or getCategories'),
        searchQuery: zod_1.z.string().optional().describe('The search query for products (required for searchProducts operation). Can be product names, descriptions, or keywords.'),
        categoryId: zod_1.z.number().optional().describe('Optional category ID to filter products within a specific category (for searchProducts operation)'),
        limit: zod_1.z.number().optional().describe('Maximum number of products to return (for searchProducts operation, default: 10)'),
        isComparingProducts: zod_1.z.boolean().describe('Indicates whether the user is asking to compare specific products (true) or looking for general category recommendations (false). This helps determine how to use the products array and searchQuery.')
    }),
    blockStream: false
};
